import type {
  ApplicationEmailsQuery,
  ApplicationEmailsQueryVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';
import hirerGraphqlClient from './client';
import { query } from './schema/queryApplicationEmails';

interface FetchApplicationEmailsInput {
  prospectId: string;
  adcentreCandidateId: string;
}

export const fetchApplicationEmails = async (
  input: FetchApplicationEmailsInput,
) => {
  const { data } = await hirerGraphqlClient.query<
    ApplicationEmailsQuery,
    ApplicationEmailsQueryVariables
  >({
    variables: {
      input,
    },
    query,
  });
  if (data === null) {
    throw new Error('graphql error fetching application emails');
  }
  const emails = data.applicationEmails.edges
    .map(({ node: email }) => ({
      id: email.id,
      subject: email.subject,
      message: email.message,
      sentDate: email.sentDate,
      from: email.from,
      to: email.to,
      candidateId: email.adcentreCandidateId,
      prospectId: email.prospectId,
    }))
    .sort((email1: Record<string, any>, email2: Record<string, any>) =>
      (email2.sentDate as string).localeCompare(email1.sentDate as string),
    );
  return emails;
};
